import { Modal } from "bootstrap";
const ModalEmbeded = {
    init: () => {
        const $btnModalEmbeds = document.querySelectorAll('[data-target="#modalEmbeded"]');
        if ($btnModalEmbeds.length === 0)
            return;
        ModalEmbeded.loop($btnModalEmbeds);
    },
    loop: (elements) => {
        elements.forEach((element) => {
            element.addEventListener("click", (event) => {
                const eventTarget = event.currentTarget;
                const { target, videoId } = eventTarget.dataset;
                const id = target.split("#")[1];
                const previousModal = document.getElementById(id);
                if (previousModal) {
                    document.getElementById(id).remove();
                }
                const div = document.createElement("div");
                div.setAttribute("id", id);
                div.setAttribute("tabindex", "-1");
                div.classList.add("modal");
                div.classList.add("fade");
                div.classList.add("modal-embeded");
                div.innerHTML = `
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="icon-x"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/${videoId}?rel=0" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>`;
                document.body.append(div);
                const $modal = new Modal(document.getElementById(id));
                $modal.show();
                ModalEmbeded.hide(document.getElementById(id));
                event.preventDefault();
            });
        });
    },
    hide: (modal) => {
        modal.addEventListener("hide.bs.modal", () => {
            modal.querySelector("iframe").setAttribute("src", ``);
        });
    },
};
export default ModalEmbeded;
